import tw from "src/utils/tw";

interface Props {
  full?: boolean;
  children?: any;
  className?: string;
  white?: boolean;
}

export default function ListSectionHeader(props: Props) {
  return (
    <div
      className={tw(
        props.white ? "bg-white" : "bg-bgGray",
        "border-borderGray",
        "border-t",
        "border-b",
        "m-auto",
        "py-2",
        "border-collapse",
        props.full ? "max-w-none" : "max-w-[800px]",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
